module.exports = __webpack_public_path__ + "img/icon7.bdf8361.webp";